<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ addGiftCardContent.title }}
    </Teleport>

    <p class="cf-subtitle cf-subtitle--2">
      {{ addGiftCardContent.description }}
    </p>

    <cf-add-gift-card :payment-gateway="paymentGateway" />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfAddGiftCard from './cf-add-gift-card/index.vue';


  export default {
    name: 'AddGiftCardAtCheckout',

    components: {
      CfAddGiftCard
    },

    props: {
      paymentGateway: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('session', ['session']),
      ...mapGetters('content', ['content']),

      addGiftCardContent() {
        const content = this.content.AddGiftCardAtCheckout;

        return {
          title: content.title,
          description: content.description
        };
      }
    }
  };
</script>
